import {
	Text,
	View,
	StyleSheet,
	Pressable,
	FlatList,
	Image,
} from "react-native";
import { AntDesign } from "@expo/vector-icons";

const forYou = require("../../assets/images/forYou.png");
const forYou2 = require("../../assets/images/forYou2.png");
const forYou3 = require("../../assets/images/forYou3.png");

const DiscountsForYouRail = () => {
	const staticDiscounts = [
		{
			id: 0,
			title: "50% de desconto em todos os cinemas do Brasil",
			backgroundColor: "#0843F5",
			constratColor: "#fff",
			imageSrc: forYou,
		},
		{
			id: 1,
			title: "Meia entrada no Museu de Arte de São Paulo (MASP)",
			backgroundColor: "#DDF664",
			constratColor: "#133262",
			imageSrc: forYou2,
		},
		{
			id: 2,
			title: "7% de desconto em todos os produtos da Petz",
			backgroundColor: "#3FCCCC",
			constratColor: "#fff",
			imageSrc: forYou3,
		},
	];

	return (
		<View style={styles.container}>
			<View style={styles.header}>
				<Text style={styles.headerTitle}>Para você</Text>
				<Pressable onPress={() => alert("oi")}>
					<Text style={styles.headerReadMore}>Ver mais</Text>
				</Pressable>
			</View>
			<View>
				<FlatList
					horizontal
					data={staticDiscounts}
					ListFooterComponent={() => <View></View>}
					renderItem={({ item, index }) => (
						<View
							style={[
								styles.item,
								{
									marginLeft: index === 0 ? 24 : 0,
								},
							]}
						>
							<View
								style={{
									backgroundColor: item.backgroundColor,
									height: "50%",
									paddingLeft: 20,
									paddingRight: 40,
									paddingVertical: 15,
								}}
							>
								<Text
									style={{
										color: item.constratColor,
										fontSize: 18,
										lineHeight: 20,
										fontFamily: "DmSans-bold",
									}}
								>
									{item.title}
								</Text>
							</View>
							<Image source={item.imageSrc} style={styles.image} />
							<Pressable
								onPress={() => alert("oi!")}
								style={{
									backgroundColor: item.backgroundColor,
									height: 38,
									width: 38,
									position: "absolute",
									right: 15,
									bottom: 15,
									borderRadius: 50,
									justifyContent: "center",
									alignItems: "center",
								}}
							>
								<AntDesign
									name="arrowright"
									size={20}
									color={item.constratColor}
									style={{ position: "absolute" }}
								/>
							</Pressable>
						</View>
					)}
				/>
			</View>
		</View>
	);
};

export default DiscountsForYouRail;

const styles = StyleSheet.create({
	container: {
		marginBottom: 20,
	},
	header: {
		flexDirection: "row",
		marginBottom: 12,
		paddingHorizontal: 24,
		justifyContent: "space-between",
	},
	headerTitle: {
		fontSize: 18,
		lineHeight: 26,
		color: "#3C351F",
		fontFamily: "DmSans-bold",
	},
	headerReadMore: {
		fontFamily: "DmSans-bold",
		fontSize: 14,
		color: "#0843F5",
		marginTop: 3,
	},
	item: {
		width: 222,
		height: 180,
		marginRight: 15,
		overflow: "hidden",
		borderRadius: 20,
		//flex: 1,
	},
	image: {
		flex: 1,
	},
});
